module.exports = __webpack_public_path__ + "static/media/expressive4.f9b230e7.png";